import axios from 'axios'
import authToken from '../functions/authToken'

import admin from './modules/admin'
import auth from './modules/auth'
import coach from './modules/coach'
import coachee from './modules/coachee'
import coaching from './modules/coaching'
import password from './modules/password'
import session from './modules/session'
import signup from './modules/signup'
import user from './modules/user'

axios.defaults.baseURL = '/api/'

axios.interceptors.request.use(config => {
  const token = authToken.get()

  if (token) {
    config.headers.Authorization = `Token ${token}`
  }

  return config
}, error => Promise.reject(error))

export default {
  admin,
  auth,
  coach,
  coachee,
  coaching,
  password,
  session,
  signup,
  user
}
